
import axios from "axios";

const instance = axios.create({
  //  baseURL: "http://localhost:3000/api/",
  // baseURL: "http://145.223.20.90:3000/api/",
  baseURL: 'https://melmons-backend.onrender.com/api/',

  //  baseURL: "/api/",

  // withCredentials: true,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
